import { createRef } from 'react';

export const canvasContainerRef = createRef<HTMLDivElement>();

